import React from "react";
import PropTypes from "prop-types";
import { selectOptionType } from "custom-prop-types";

import styles from "components/documents/gst-calculator.scss";
import { calculateGST } from "utils/gst";

export const GSTCalculator = ({
  change,
  currency,
  preferredCurrency,
  taxRate,
  total
}) => {
  if (currency === preferredCurrency || currency.key === preferredCurrency) {
    const gst = calculateGST(total, currency, taxRate);
    return (
      <button
        className={ styles["gst-button"] }
        onClick={ (e) => { e.preventDefault(); change("tax", gst); } }
      >
      Calculate GST
    </button>
    );
  }
  return null;
};

GSTCalculator.propTypes = {
  change: PropTypes.func.isRequired,
  currency: selectOptionType.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  taxRate: PropTypes.number.isRequired,
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/gst-calculator.jsx